export let goToMailCommand = "R5yQJe";
export let goToCalendarCommand = "uX84cc";
export let goToHostedAppCommand = "kpQJYc";
export let goToPreviousViewCommand = "_0cL8c";
export let goToNextViewCommand = "ot47Xb";
export let goToDevToolsCommand = "wIiz0b";
export let goToEdgeTracingToolsCommand = "ogdjxb";
export let jumpFocus = "CL$_Nd";
export default {goToMailCommand,goToCalendarCommand,goToHostedAppCommand,goToPreviousViewCommand,goToNextViewCommand,goToDevToolsCommand,goToEdgeTracingToolsCommand,jumpFocus};